import { Record, Map, List } from "immutable";
import { AnyAction } from "redux";

import { defaultValues } from "@config/defaultValues";

import { CANCELLATION_STATE } from "@typings/jobs";
import { PAYMENT_METHODS } from "@typings/globals";

import {
  ACTION_SUCCESS,
  ACTION_FAIL,
} from "@services/AsyncActionCreatorFactory";

import { CancellationFactory } from "../jobs2/jobs2.factories";

import {
  FETCH_JOBS,
  SET_PAYMENT_METHOD,
  FETCH_PAYMENT_METHODS,
  CANCEL_START,
  CANCEL_REASON,
} from "./bookingsToValidate.actions";
import { JobsFactory } from "./bookingsToValidate.factories";
import { BookingsToValidateReducer } from "./bookingsToValidate.typings";

const initialState = Record<BookingsToValidateReducer>({
  jobs: Map(),
  availablePaymentMethods: List(),
  selectedPaymentMethod: defaultValues.bookingsToValidate.selectedPaymentMethod,
});

const bookingsToValidateReducer = (
  store: Record<BookingsToValidateReducer> = initialState(),
  action: AnyAction,
): Record<BookingsToValidateReducer> => {
  const { type, payload } = action;

  switch (type) {
    case `${FETCH_JOBS}${ACTION_SUCCESS}`:
      return store.set("jobs", JobsFactory(payload.data));
    case `${FETCH_PAYMENT_METHODS}${ACTION_SUCCESS}`: {
      return store.set(
        "availablePaymentMethods",
        List<PAYMENT_METHODS>(payload.data),
      );
    }
    case SET_PAYMENT_METHOD: {
      return store.set("selectedPaymentMethod", payload);
    }
    case `${CANCEL_START}${ACTION_SUCCESS}`: {
      const { params } = action;
      const { data } = payload;

      return store.setIn(
        ["jobs", params.id, "cancellationProcess"],
        CancellationFactory(data),
      );
    }

    case `${CANCEL_START}${ACTION_FAIL}`: {
      const { params } = action;

      return store.setIn(
        ["jobs", params.id, "cancellationState"],
        CANCELLATION_STATE.FAILED,
      );
    }

    case `${CANCEL_REASON}${ACTION_SUCCESS}`: {
      const { params } = action;

      return store.removeIn(["jobs", params.id]);
    }
    default: {
      return store;
    }
  }
};

export { bookingsToValidateReducer };
